




























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  AppHeader,
  AppFooter,
  SideNavigation,
  NewRequestModal,
  GlobalSnackbar,
  UserModal,
} from '@/components/_common';

@Component({
  components: {
    AppHeader,
    AppFooter,
    SideNavigation,
    NewRequestModal,
    GlobalSnackbar,
    UserModal,
  },
})
export default class App extends Vue {
  get isLoginView() {
    return this.$route.name !== 'Log In';
  }
}
